// @ts-nocheck

import React from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../hooks/useMergeProps';
import useRouter from '../../hooks/useRouter';

import Basket from './Basket';
import selectBasketProps from './Basket.selector';

type PropsType = {
  closeModal?: () => void;
};

const BasketContainer = (ownProps: PropsType) => {
  const { location } = useRouter();
  const selectedProps = useSelector((state) => selectBasketProps(state, { location }));

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return <Basket {...enhancedProps} />;
};

export default React.memo<PropsType>(BasketContainer);
